'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const GroupIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M8.75 21.53C8.75 16.25 11.55 12.82 15 12.82C18.45 12.82 21.25 16.25 21.25 21.53M10.75 11.99C9.9 11.02 8.8 10.48 7.59 10.48C4.92 10.48 2.75 13.14 2.75 17.22M15 4.33997C13.27 4.33997 11.88 5.73997 11.88 7.46997C11.88 9.19997 13.28 10.6 15 10.6C16.72 10.6 18.12 9.19997 18.12 7.46997C18.12 5.73997 16.72 4.33997 15 4.33997ZM7.59 3.21997C6.25 3.21997 5.17 4.29997 5.17 5.63997C5.17 6.97997 6.25 8.05997 7.59 8.05997C8.93 8.05997 10.01 6.97997 10.01 5.63997C10.01 4.29997 8.93 3.21997 7.59 3.21997Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpGroupIcon = forwardRef(GroupIcon);

export { VpGroupIcon as default };
